// Colours
import { emeraldGreen, terracotta } from "Constants/ColourConstants";

export const styles = {
  navBar: {
    background: emeraldGreen,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    justifyContent: "center",
  },
  title: {
    fontWeight: "bold",
    cursor: "pointer",
  },
  signOutButton: {
    background: "white",
    borderRadius: 30,
    color: terracotta,
  },
};
